import React, { useState } from 'react';
import classnames from 'classnames';
import Icon from '@mdi/react';
import { mdiCheck, mdiArrowLeft } from '@mdi/js';

import { FloatingMenu } from 'UI';
import { useProfile } from 'hooks';
import { GraphqlShield } from 'utils';
import { Button, Input, Text } from 'design-system';

const UsernameSuccess = ({ username }) => {
  return (
    <div className="password-success">
      <Icon path={mdiCheck} />
      <Text>Waouw {username} ! Super nom !</Text>
    </div>
  );
};

const ChangeUsername = props => {
  const { navigation, className } = props;
  const [newUsername, setNewUsername] = useState('');
  const [success, setSuccess] = useState(false);
  const { updateMe, profile } = useProfile();

  async function handleSubmit(e) {
    e.preventDefault();
    await updateMe({
      variables: {
        input: {
          username: newUsername,
        },
      },
    });
    setSuccess(true);
  }

  return (
    <div className={classnames(className, 'slide', 'change-password-slide')}>
      <FloatingMenu.Header
        className="clickable"
        onClick={() => navigation.pop()}
      >
        <span className="back-icon">
          <Icon path={mdiArrowLeft} />
        </span>
        Gérer mon nom d'utilisateur-ice
      </FloatingMenu.Header>
      <FloatingMenu.Body>
        {success && <UsernameSuccess username={profile.username} />}
        {!success && (
          <div className="form">
            <Input
              type="text"
              label="Nouveau nom d'utilisateur-ice"
              placeholder=""
              value={newUsername}
              onChange={e => setNewUsername(e.target.value)}
            />

            <Button
              label="Valider"
              variant="primary"
              size="large"
              fullWidth
              onClick={handleSubmit}
            />
          </div>
        )}
      </FloatingMenu.Body>
    </div>
  );
};

function ChangeUsernameSlide(props) {
  return (
    <GraphqlShield>
      {(errors = []) => <ChangeUsername {...props} errors={errors} />}
    </GraphqlShield>
  );
}

export default ChangeUsernameSlide;
